<template>
  <v-layout>
    <v-flex>
      <v-card>
        <v-card-title>Promocodes generation</v-card-title>
        <v-card-text>
          <v-layout align-center>
            <v-flex xs3>
              <v-text-field ref="input" v-model="promoCode" placeholder="Promocode id" hide-details></v-text-field>
            </v-flex>
            <v-flex xs3>
              <v-btn color="purple" @click="generatePromo" dark>Generate</v-btn>
              <v-btn color="purple" :disabled="!promoCode" :dark="!!promoCode" @click="copy">copy</v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
    <show-modal v-model="showDialog" :message="message"></show-modal>
  </v-layout>
</template>

<script>
import axios from "axios";
import showModal from "./ShowModal";

export default {
  name: "GeneratePromo",

  components: {
    showModal
  },

  data: () => ({
    promoCode: "",
    showDialog: false,
    message: ""
  }),

  methods: {
    copy() {
      let input = this.$refs.input.$el.querySelectorAll("input")[0];
      input.select();
      document.execCommand("copy");
      this.showDialog = true;
      this.message = "Promocode has been copied";
    },

    generatePromo() {
      axios
        .get(this.$hostname + "/admin/get_promocode", {
          headers: {
            Authorization: localStorage.getItem("token")
          }
        })
        .then(response => {
          console.log(response);
          this.promoCode = response.data.promocode;
        })
        .catch(error => {
          this.showDialog = true;
          this.dialogMessage = `${error.response.data.message}`;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.v-card__title {
  background-color: #383838;
  color: #fff;
}
</style>
